import * as signalR from "@microsoft/signalr";
import { IMAGE_BASE_URL } from './config';

// Each mounted admin screen owns its transport and its cleanup closure.
export const startOrderConnection = (restaurantId, onMessage, factory = () =>
  new signalR.HubConnectionBuilder()
    .withUrl(IMAGE_BASE_URL + "/tableHub", {
      accessTokenFactory: () => localStorage.getItem("Admin-API-Token") || ""
    })
    .configureLogging(signalR.LogLevel.Information)
    .withAutomaticReconnect().build(), onReady = () => {}) => {
  const connection = factory();
  let disposed = false;
  let busy = false;
  let retryTimer;
  let failures = 0;
  const seen = new Set();
  const receive = data => {
    if (disposed) return;
    if (data.notificationId) {
      if (seen.has(data.notificationId)) return;
      seen.add(data.notificationId);
      if (seen.size > 500) seen.delete(seen.values().next().value);
    }
    onMessage(data);
  };
  const schedule = () => {
    if (disposed || retryTimer) return;
    retryTimer = setTimeout(() => {
      retryTimer = undefined;
      connect();
    }, Math.min(2000 * 2 ** Math.min(failures++, 4), 30000));
  };
  const connect = async () => {
    if (disposed || busy) return;
    busy = true;
    try {
      if (connection.state === signalR.HubConnectionState.Disconnected) await connection.start();
      if (disposed) { await connection.stop(); return; }
      if (connection.state !== signalR.HubConnectionState.Connected) { schedule(); return; }
      await connection.invoke("JoinRestaurant", String(restaurantId).trim().toLowerCase());
      if (connection.state !== signalR.HubConnectionState.Connected) { schedule(); return; }
      clearTimeout(retryTimer);
      retryTimer = undefined;
      failures = 0;
      if (!disposed) onReady();
    } catch (error) {
      if (!disposed) {
        console.warn("Restaurant notification connection/join failed; retrying.", error);
        schedule();
      }
    } finally { busy = false; }
  };
  connection.on("RestaurantNotification", receive);
  connection.onreconnected(connect);
  connection.onclose(schedule);
  connect();
  return () => {
    disposed = true;
    clearTimeout(retryTimer);
    connection.off("RestaurantNotification", receive);
    connection.stop().catch(error => console.warn("Notification connection stop failed.", error));
  };
};
